import { Injectable } from '@angular/core';
import { AngularFirestoreDocument, AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { map } from 'rxjs/operators';
import { Client } from '../models/client.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  database = 'Clients';
  databaseTrash = 'ClientsTrash';
  roomEscapeDoc: AngularFirestoreDocument<Client>;
  constructor(
    private afs: AngularFirestore) { }


  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  } get ref() {
    return firebase.firestore().collection(this.database);
  }

  create(client: Client) {
    client.i = this.afs.createId();
    const id = client.i;
    const data = {};
    data[client.i] = Object.assign({}, client);
    return this.ref.firestore.doc(this.database + '/Clients').set(data, {merge: true});
  }
  edit(client: Client) {
    const data = {};
    data[client.i] = Object.assign({}, client);
    return this.ref.firestore.doc(this.database + '/Clients').set(data, { merge: true });
  }
  remove(client: Client) {
    const data = {};
    data[client.i] = Object.assign({}, client);
    this.ref.firestore.doc(this.databaseTrash + '/Clients').set(data, { merge: true});
    data[client.i] = firebase.firestore.FieldValue.delete();
    return this.ref.firestore.doc(this.database + '/Clients').update(data);
  }
  editVisible (client: Client, visible: boolean) {
    const data = {};
    client.v = visible;
    data[client.i] = Object.assign({}, client);
    this.ref.firestore.doc(this.database + '/Clients').set(data, { merge: true});
  }
  getAll() {
    return this.afs.doc<Client>(this.database + '/Clients').snapshotChanges().pipe(
        map(action => {
            if (action.payload.data()) {
                const clients = [];
                Object.keys(action.payload.data()).map(key => {
                    clients.push(action.payload.data()[key]);
                });
                return clients;
            }
            return [];
        })
    );
  }
}
